<template lang="pug">
.RemainTimeIndicator
  .guage
    .guageBody(:style="{width: ((time / maxTime) * 100) + '%' }")
  .label
    | 残り時間
    .time(v-for="tick in parsedTime") {{ tick }}
    | 秒

</template>

<script>
// import moment from 'moment'
// import soundService from '@/services/SoundService'

export default {
  name: 'km-remain-time-indicator',
  components: {},
  props: ['time', 'maxTime'],
  data() {
    return {}
  },
  computed: {
    parsedTime: function() {
      // return moment.utc(this.time * 1000).format('HH:mm:ss')
      return this.time ? ('000' + this.time).slice(-3).split('') : [0, 0, 0]
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
.RemainTimeIndicator {
  position: relative;

  // .guage {
  //   width: 100%;
  //   height: 5px;
  //   background: gray;

  //   .guageBody {
  //     height: 5px;
  //     background: #6CD370;
  //     transition: width ease 0.5s;
  //   }

  // }

  .label {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 2rem;

    .time {
      margin: 0 2px 0 0;
      padding: 5px;
      background: #fff;
      color: #000;
      font-size: 2.5rem;

      &:first-child {
        margin-left: 10px;
      }

      &:last-child {
        margin-right: 10px;
      }
    }
  }
}
</style>
